import React from 'react'
import DateDisplay from '../components/DateDisplay'
import ReservatorTablets from '../components/ReservatorTablets'

const HomePage: React.FC = () => {
    return (
        <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <h1 style={{ fontSize: '4em' }}>Kumpula Monitor</h1>
            <DateDisplay />
            <ReservatorTablets />
        </div>
    )
}

export default HomePage
